import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

// Root selectors
const getHistoryState = (state: RootState) => state.history;

export const getHistoryDataSelector = createSelector(
  [getHistoryState],
  (history) => history?.historyData,
);

export const getUpdatedTicketOrCaseNumberSelector = createSelector(
  [getHistoryState],
  (history) => history.updatedTicketOrCaseNumber,
);

export const getTimestampSelector = createSelector(
  [getHistoryState],
  (history) => history.timestamp,
);

export const getStatusSelector = createSelector(
  [getHistoryState],
  (history) => history?.status,
);

export const getHistoryDialNumberValidateStatusSelector = createSelector(
  [getHistoryState],
  (history) => history.historyDialNumberValidateStatus,
);

export const getHistoryLoadingSelector = createSelector(
  [getHistoryState],
  (history) => history?.showLoadingIndicator,
);
